import React from 'react'
import PicklistField from 'core/components/validatedForm/DropdownField'
import ClusterPicklist from 'k8s/components/common/ClusterPicklist'
import UserMultiSelect from 'k8s/components/common/UserMultiSelect'
import GroupMultiSelect from 'k8s/components/common/GroupMultiSelect'
import RolePicklist from './RolePicklist'
import TextField from 'core/components/validatedForm/TextField'
import useParams from 'core/hooks/useParams'
import useReactRouter from 'use-react-router'
import FormFieldSection from 'core/components/validatedForm/FormFieldSection'
import DocumentMeta from 'core/components/DocumentMeta'
import { routes } from 'core/utils/routes'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { createClusterRoleBinding } from './new-actions'
import ModalForm from 'core/elements/modal/ModalForm'
import usePluginRouter from 'core/hooks/usePluginRouter'

const defaultParams = {
  clusterId: '', // Initialize here to prevent desync with formContext
  clusterRole: null,
  users: [],
  groups: [],
}
export default function AddClusterRoleBindingForm() {
  const { params, getParamsUpdater, setParams } = useParams(defaultParams)
  const { history } = useReactRouter()
  const { currentPluginId } = usePluginRouter()

  const { update, updating, reset, error: errorCreatingClusterRoleBinding } = useUpdateAction(
    createClusterRoleBinding,
  )

  const submitForm = async (params) => {
    const { success } = await update(params)
    if (success) handleClose()
  }
  const handleClose = () => {
    setParams(defaultParams)
    reset()
    history.push(routes.rbac.clusterRoleBindings.path({ plugin: currentPluginId }))
  }

  return (
    <>
      <DocumentMeta title="Add Cluster Role Binding" bodyClasses={['form-view']} />
      <ModalForm
        route={routes.rbac.addClusterRoleBindings}
        title="Add Cluster Role Binding"
        onSubmit={submitForm}
        onClose={handleClose}
        submitting={updating}
        error={errorCreatingClusterRoleBinding}
        submitTitle="Add Cluster Role Binding"
      >
        <>
          <FormFieldSection title="Basic Details" step={1}>
            <TextField id="name" label="Name" required />
            <PicklistField
              DropdownComponent={ClusterPicklist}
              id="clusterId"
              label="Cluster"
              onChange={getParamsUpdater('clusterId')}
              value={params.clusterId}
              setInitialCluster
              compact={false}
              showAll={false}
              required
            />
            <PicklistField
              DropdownComponent={RolePicklist}
              disabled={!params.clusterId}
              id="clusterRole"
              label="Cluster Role"
              clusterId={params.clusterId}
              onChange={getParamsUpdater('clusterRole')}
              value={params.clusterRole}
              compact={false}
              required
            />
          </FormFieldSection>
          <FormFieldSection title="Assign Users to this Cluster Binding" step={2}>
            <UserMultiSelect
              id="users"
              tooltip="Select users to assign this role"
              onChange={getParamsUpdater('users')}
              value={params.users}
            />
          </FormFieldSection>
          <FormFieldSection title="Assign Groups to this Cluster Binding" step={3}>
            <GroupMultiSelect
              id="groups"
              tooltip="Select groups to assign this role"
              onChange={getParamsUpdater('groups')}
              value={params.groups}
            />
          </FormFieldSection>
        </>
      </ModalForm>
    </>
  )
}
